import React, { Component } from "react";

const ErrorTypeText = ({ error }) => {
  switch (error) {
    case 0:
      return "Unit not found";
    case 1:
      return "Unit could not be converted";
    case 2:
      return "This vendor code does not have a reference to a graziano's item";
    default:
      return "The item information couldn’t be processed";
  }
};

const Error = ({ error, toggleReprocessPriceModal }) => {
  return (
    <tr>
      <td>{error.recovery_code}</td>
      <td>{<ErrorTypeText error={error.error} />}</td>
      <div className="card-block p-0" style={{ overflow: "hidden" }}>
        <div className="table-responsive-custom">
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                {Object.keys(error.raw_offer_data).map((key) => (
                  <th>{key}</th>
                ))}
              </tr>
            </thead>
            {Object.values(error.raw_offer_data).map((error) => (
              <td>{error}</td>
            ))}
          </table>
        </div>
      </div>
      <td>
        <span className="ml-05 btn btn-sm btn-primary mr-0" onClick={() => toggleReprocessPriceModal(error)}>
          <i className="fa fa-wrench"></i>
        </span>
      </td>
    </tr>
  );
};

export default class PricesListErrors extends Component {
  render() {
    const { pricesList, toggleReprocessPriceModal } = this.props;
    return (
      <tbody>
        {pricesList &&
          pricesList.map((error) => {
            return <Error error={error} key={error.id} toggleReprocessPriceModal={toggleReprocessPriceModal} />;
          })}
      </tbody>
    );
  }
}
